import { React, memo } from 'react'
import { useTranslation } from "react-i18next";
import './SpecialBilling.css';
import "react-tabs/style/react-tabs.css";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import RequestSpecialBilling from './RequestSpecialBilling/RequestSpecialBilling';
import CancelSpecialBilling from './CancelSpecialBilling/CancelSpecialBilling';

const SpecialBilling = () => {
    const { t } = useTranslation();

    return (
        <>
            <div className="Detail_tabs">
                <Tabs>
                    <TabList>
                        <div style={{display:"flex"}}>
                        <Tab  className='tabRequestSpecial'><span className='TextHead'>{t('RequestSpecialBilling')}</span></Tab>
                        <Tab className='tabCancelSpecial'><span className='TextHead'>{t('CancelSpecialBilling')}</span></Tab>
                        </div>
                    </TabList>
                    <TabPanel>
                        <RequestSpecialBilling />
                    </TabPanel>

                    <TabPanel>
                        <CancelSpecialBilling />
                    </TabPanel>
                </Tabs>
            </div>
        </>
    )
}

export const MemorizedCorrectiveDetail = memo(SpecialBilling);